import { THEMATIC_MEETING_TOPICS } from './index';

import type { ThematicMeetingTopic } from './index';

/**
 * What another page hands the meetings page when it wants the "plan a meeting" wizard open on
 * arrival, with the employee and the topic already picked -- the Growth tab's "Réévaluer" sends
 * the employee and `Career`. Travels as router location state, so a refresh of the meetings page
 * never reopens the wizard.
 */
export interface NewMeetingPrefill {
    employeeId: string;
    topic: ThematicMeetingTopic;
}

/** A type literal rather than an interface: the navigation hook takes an indexable state. */
export type NewMeetingLocationState = {
    newMeeting: NewMeetingPrefill;
};

export const toNewMeetingLocationState = (prefill: NewMeetingPrefill): NewMeetingLocationState => ({
    newMeeting: prefill,
});

const isTopic = (value: unknown): value is ThematicMeetingTopic =>
    THEMATIC_MEETING_TOPICS.some((topic) => topic === value);

/**
 * The prefill carried by a location state, or `null` when the page was reached any other way or
 * the state names a topic the catalog does not know (state is whatever the previous page wrote).
 */
export const readNewMeetingPrefill = (state: unknown): NewMeetingPrefill | null => {
    if (typeof state !== 'object' || state === null || !('newMeeting' in state)) {
        return null;
    }
    const { newMeeting } = state as { newMeeting?: Partial<NewMeetingPrefill> };
    return newMeeting && typeof newMeeting.employeeId === 'string' && isTopic(newMeeting.topic)
        ? { employeeId: newMeeting.employeeId, topic: newMeeting.topic }
        : null;
};
